import CurrencyBox from './CurrencyBox';

export default CurrencyBox;
